<template>
  <div class="qyh_public_auto_message" >
    <el-divider content-position="left">企业火被关注回复</el-divider>
    <el-row>
      <el-card shadow="never">
        <div>
          <el-input
            :autosize="{ minRows: 4, maxRows: 12 }"
            resize='none'
            type="textarea"
            placeholder="请输入内容"
            v-model="msg">
          </el-input>
        </div>
        <div class="editor_toolbar">
          <span>
            <p class="edit_text">按下Enter键换行</p>
            <p class="edit_text" :class="msg.length > 600 ? 'text-error' : ''">{{ surplus }}</p>
          </span>
        </div>
      </el-card>
    </el-row>
    <el-row class="tr mt10">
      <el-button type="primary" size="small" @click="subFrom">保存</el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'WxPublicAutoMessage',
  data () {
    return {
      msg: ''
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
    surplus() {
      let num = 600 - this.msg.length
      if (num >= 0) {
        return '还可以输入 ' + num + ' 字，' 
      } else {
        return '已超出 ' + (0 - num) + ' 字，'
      }
    }
  },
  methods: {
    getMsg () {
      this.$axios.get('/api/admin/auto_wx_public_msg')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.msg = data.data.msg
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    subFrom () {
      if (this.msg.length > 600) {
        return this.$message.error('自动回复内容超出字数限制')
      }

      this.$confirm('确认发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmSubForm()
      }).catch(() => {})
    },
    confirmSubForm () {
      this.$axios.post('/api/admin/auto_wx_public_msg/onSubscribe', {msg: this.msg})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getMsg()
  }
}
</script>

<style lang="stylus" scoped>
.qyh_public_auto_message {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.qyh_public_auto_message >>> .el-card__body {
  padding: 0;
}

.el-textarea {
  overflow: hidden;
}

.el-textarea  >>> .el-textarea__inner {
  border: none;
}

.edit_area {
  padding: 14px 20px;
  height: 188px;
  line-height: 1.5;
  overflow: auto;
}

.editor_toolbar {
  padding: 0 20px;
  line-height: 36px;
  border-top: 1px solid #E3E4E5;
}

.edit_text {
  float: right;
  color: #B1B2B3;
  font-size: 14px;
}

.text-error {
  color: #FA5151;
}

.tr {
  text-align: right;
}

.mt10 {
  margin-top: .2rem
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxPublicConfig/WxPublicAutoMessage.vue